import { createSlice } from "@reduxjs/toolkit";


interface UserDataProps {
    loginData: {},
}

const initialState: UserDataProps = {
  loginData: {},
};


const userData = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setLoginData(state, action) {
      state. loginData = action.payload;
    },
  },
});

export default userData.reducer;

export const { setLoginData } = userData.actions;
